import { render, staticRenderFns } from "./RepaymentScheduleTab.vue?vue&type=template&id=4673504c&scoped=true&"
import script from "./RepaymentScheduleTab.vue?vue&type=script&lang=js&"
export * from "./RepaymentScheduleTab.vue?vue&type=script&lang=js&"
import style0 from "./RepaymentScheduleTab.vue?vue&type=style&index=0&id=4673504c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4673504c",
  null
  
)

export default component.exports